import Sidemenu from './Sidemenu';

export default function SideLogin({
  languageSelector,
  qualifier,
}: {
  languageSelector: React.ReactNode;
  qualifier?: string;
}) {
  return (
    <Sidemenu
      menuItems={[]}
      languageSelector={languageSelector}
      qualifier={qualifier}
    />
  );
}
